import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, Zoom } from 'react-toastify';
import useOfflineDetection from '../hooks/use-offline-detection';
import { NAVBAR_HEIGHT } from '../components/Navbar';
import { HelmetProvider } from 'react-helmet-async';
import { PreferencesProvider } from '../contexts/preferences';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ThemeProvider } from 'styled-components';
import theme from '../theme';
import * as CrashReporter from '../crash-reporter';
import FullScreenAlert from '../components/Alert/FullScreenAlert';

const queryClient = new QueryClient();

export default function AppWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  useOfflineDetection();

  return (
    <CrashReporter.ErrorBoundary
      FallbackComponent={() => (
        <FullScreenAlert text="Unfortunately, something went wrong" />
      )}
    >
      <ToastContainer
        theme="dark"
        transition={Zoom}
        position="bottom-right"
        className="enki-toast-container"
        toastClassName="enki-toast"
        progressClassName="enki-toast-progress"
        style={{
          bottom: NAVBAR_HEIGHT,
        }}
      />
      <HelmetProvider>
        <PreferencesProvider>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
          </QueryClientProvider>
        </PreferencesProvider>
      </HelmetProvider>
    </CrashReporter.ErrorBoundary>
  );
}
